import React from 'react';
import { useTranslation } from 'react-i18next';
import { useUnit } from 'effector-react';
import { Field } from 'formik';
import { Typography } from '@mui/material';
import { TypeSimpleTreeField } from '@features/tickets-new-type-simple-tree';
import { BaseInputLabel } from '@ui/index';
import {
  $activeTypesIds,
  $ticketsCountByTypesIds,
  $ticketsCountWithoutType,
} from '../../../../models/replace-employee';
import { ReplaceEmployeeForm } from '../../../../models/replace-employee/types';
import * as Styled from '../../styled';
import { NoTypeCheckbox } from '../noTypeCheckbox';

export const TypesTree = ({
  values,
  setFieldValue,
}: {
  values: ReplaceEmployeeForm;
  setFieldValue: (field: string, value: any) => void;
}) => {
  const { t } = useTranslation();
  const [activeTypesIds, ticketsCountByTypesIds, ticketsCountWithoutType] = useUnit([
    $activeTypesIds,
    $ticketsCountByTypesIds,
    $ticketsCountWithoutType,
  ]);

  const noAnyTypes = !activeTypesIds?.length && !ticketsCountWithoutType;

  const componentKey = JSON.stringify([
    ...(activeTypesIds ?? []),
    ticketsCountWithoutType,
  ]);

  return (
    <React.Fragment key={componentKey}>
      {!values.replaceableEmployee && (
        <>
          <BaseInputLabel>
            {t('SubstituteWorker.SelectTicketsToSubstitute')}
          </BaseInputLabel>
          <Typography variant="caption">
            {t('SubstituteWorker.FirstYouNeedToSelectWorkerToSubstitute')}
          </Typography>
        </>
      )}

      {noAnyTypes && values.replaceableEmployee && (
        <>
          <BaseInputLabel>
            {t('SubstituteWorker.SelectTicketsToSubstitute')}
          </BaseInputLabel>
          <Typography variant="caption">
            {t('SubstituteWorker.NoActiveTickets')}
          </Typography>
        </>
      )}

      {!noAnyTypes && values.replaceableEmployee && (
        <Styled.TypesFieldWrap>
          <BaseInputLabel>
            {t('SubstituteWorker.SelectTicketsToSubstitute')}
          </BaseInputLabel>

          {!!activeTypesIds?.length && (
            <Field
              id={'replace-employee'}
              name="types"
              component={TypeSimpleTreeField}
              value={values.types}
              activeIds={activeTypesIds}
              ticketsCountByIds={ticketsCountByTypesIds}
              withAcrchived={true}
              divider={false}
            />
          )}

          {!!ticketsCountWithoutType && (
            <NoTypeCheckbox
              name="withoutTypeCheckbox"
              affectTo={{
                name: 'withoutType',
                checkedValue: ticketsCountWithoutType,
                setFieldValue,
              }}
              label={t('SubstituteWorker.NoTypeTickets')}
            />
          )}
        </Styled.TypesFieldWrap>
      )}
    </React.Fragment>
  );
};
